import { Injectable } from '@angular/core';
import { marked } from 'marked';
import TurndownService from 'turndown';

@Injectable({
  providedIn: 'root',
})
export class MarkdownService {
  private turndownService: TurndownService;
  constructor() {
    this.turndownService = new TurndownService();
  }

  convertToHtml(text: string) {
    if (!text) return '';
    return marked(text);
  }

  convertToMarkdown(html: string) {
    if (!html) return '';
    return this.turndownService.turndown(html);
  }
}
